<template>
    <div>
        <Header backButton></Header>
        <div class="mt-20">
            <p
                class="text-3xl mb-10 leading-tight"
            >Conversations avec {{ (lui.attributes.custom_first_name) ? lui.attributes.custom_first_name : lui.attributes.private_pseudo }}</p>
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <div class="about mb-16" id="chat">
                <div class="chat">
                    <ul>
                        <li
                            v-for="message in messages"
                            :key="message.id"
                            :class="{ 'you': message.attributes.user_id == you.id, 'other': message.attributes.user_id != you.id}"
                        >
                            <router-link
                                class="item user"
                                :to="{path: '/profil/' +  message.attributes.user_id}"
                            >
                                <img
                                    alt
                                    :src="(message.attributes.user_id == you.id) ? (
                                    (you.attributes.custom_pictures[0]) ? you.attributes.custom_pictures[0].link : you.attributes.private_avatar
                                ) : (
                                    (lui.attributes.custom_pictures[0]) ? lui.attributes.custom_pictures[0].link : lui.attributes.private_avatar
                                )"
                                >
                            </router-link>
                            <div class="date">{{ diffDate(message.attributes.created_at) }}</div>
                            <div class="message">
                                <p>{{ message.attributes.message }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <form
                @submit="send"
                method="post"
                class="flex flex-row justify-start items-center w-full fixed pin-b"
            >
                <div class="ml-4 mr-4">
                    <i v-on:click.prevent="showPanel" class="fas fa-scroll"></i>
                </div>
                <div class="w-4/5">
                    <input
                        id="reponse"
                        class="my-5 indexUp"
                        name="reponse"
                        v-model="reponse"
                        placeholder="Reponse"
                        type="text"
                        required
                    >
                </div>
                <div class="mr-4">
                    <button>
                        <i class="fas fa-arrow-right"></i>
                    </button>
                </div>
            </form>
            <!-- <Navigation></Navigation> -->
            <slideout-panel></slideout-panel>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Navigation from "@/components/Navigation.vue";
import Quests from "@/components/panels/Quests.vue";

export default {
    name: "messages",
    components: {
        Header,
        Navigation
    },
    data() {
        return {
            reponse: null,
            messages: [],
            you: null,
            lui: { attributes: "..." },
            error: null,
            panelInstance: null,
            interval: null
        };
    },
    mounted() {
        this.callConversations();
        this.ready();
    },
    destroyed() {
        clearInterval(this.interval);
    },
    methods: {
        diffDate(updated_at) {
            let today = new Date();
            let Christmas = new Date(updated_at);
            let diffMs = Math.abs(Christmas - today); // milliseconds
            let diffDays = Math.abs(Math.floor(diffMs / 86400000)); // days
            let diffHrs = Math.abs(Math.floor((diffMs % 86400000) / 3600000)); // hours
            let diffMins = Math.abs(
                Math.round(((diffMs % 86400000) % 3600000) / 60000)
            ); // minutes
            return diffMins + " minutes";
        },
        callConversations(scrollAuto = true) {
            this.axios
                .get("/api/conversations/" + this.$route.params.id)
                .then(response => {
                    if (response.status == 200) {
                        this.messages = response.data.data.attributes.messages;
                        this.you =
                            response.data.data.attributes[
                                response.data.data.attributes.you
                            ];
                        this.lui =
                            response.data.data.attributes[
                                response.data.data.attributes.noyou
                            ];
                    }
                })
                .then(() => {
                    if (scrollAuto) this.scroll();
                })
                .catch(errors => {
                    this.error = errors.data;
                });
        },
        scroll() {
            window.scrollTo({
                behavior: "smooth",
                left: 0,
                top: document.getElementById("chat").scrollHeight
            });
        },
        send(e) {
            e.preventDefault();
            this.axios
                .post(
                    "/api/conversations/" + this.$route.params.id + "/messages",
                    {
                        message: this.reponse
                    }
                )
                .then(response => {
                    this.reponse = "";
                    this.callConversations();
                })
                .catch(errors => {
                    this.error = errors.data;
                });
        },
        ready() {
            this.interval = setInterval(() => {
                this.callConversations(false);
            }, 5000);
        },
        showPanel() {
            if (this.panelInstance) {
                this.panelInstance.show();
                return;
            }

            this.panelInstance = this.$showPanel({
                component: Quests,
                cssClass: "panel dashed-space-top",
                height: "400px",
                openOn: "bottom",
                keepAlive: true,
                props: {}
            });
        }
    }
};
</script>

<style scoped lang="scss">
.logo {
    position: fixed;
    top: -10px;
    left: -65px;
    width: 80%;
    opacity: 0.3;
}
.about {
    position: relative;
    width: 100%;
    padding: 10px 15px 20px 15px;
}

.bottom60 {
    bottom: 60px;
}

form {
    background-color: #ffffff;

    input {
        width: 100%;
        background-color: transparent;
        border-bottom: 2px dashed #4500b6;
        font-size: 1.5rem;

        &::placeholder {
            color: black;
            opacity: 0.7;
        }

        button {
            padding: 10px;
            margin-left: 20px;
        }
    }

    .fas {
        color: #4500b6;
    }
}

.pin-b {
    bottom: 0;
}

.chat {
    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            margin: 45px 0 0 0;
            font-weight: 300;

            a.user {
                margin: -30px 0 0 0;
                display: block;
                color: #333;

                img {
                    width: 65px;
                    height: 65px;
                    border-radius: 50%;
                    background-color: #f3f3f3;
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
                }
            }

            .date {
                font-size: 14px;
                color: lighten(#333, 45);
            }

            .message {
                display: block;
                padding: 10px;
                position: relative;
                color: #000000;
                font-size: 15px;
                background-color: #ffffff;
                border-radius: 10px;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);

                &:before {
                    content: "";
                    position: absolute;
                    border-top: 16px solid rgba(0, 0, 0, 0.15);
                    border-left: 16px solid transparent;
                    border-right: 16px solid transparent;
                }

                &:after {
                    content: "";
                    position: absolute;
                    top: 0;
                    border-top: 17px solid #ffffff;
                    border-left: 17px solid transparent;
                    border-right: 17px solid transparent;
                }

                &.blur {
                    p {
                        -webkit-filter: blur(3px);
                        -moz-filter: blur(3px);
                        -o-filter: blur(3px);
                        -ms-filter: blur(3px);
                        filter: blur(3px);
                    }

                    .hider {
                        opacity: 1;
                        z-index: 1;
                    }
                }

                p {
                    margin: 0;
                    padding: 0;
                    transition: all 0.1s;
                }

                .hider {
                    opacity: 0;
                    z-index: -1;
                    position: absolute;
                    height: 100%;
                    width: 100%;
                    margin: -10px;
                    text-align: center;
                    cursor: pointer;
                    transform-style: preserve-3d;
                    transition: all 0.1s;

                    span {
                        display: block;
                        position: relative;
                        top: 50%;
                        font-size: 16px;
                        transform: translateY(-50%);
                    }
                }
            }
        }

        li.you {
            a.user {
                float: right;
            }

            .date {
                float: right;
                margin: -20px 10px 0 0;
            }

            .message {
                margin: 0 90px 0 0;

                &:before {
                    margin: -9px -16px 0 0;
                    right: 0;
                }

                &:after {
                    content: "";
                    right: 0;
                    margin: 0 -15px 0 0;
                }
            }
        }

        li.other {
            a.user {
                float: left;
            }

            .date {
                float: left;
                margin: -20px 0 0 10px;
            }

            .message {
                margin: 0 0 0 90px;
                background-color: #4500b6;

                p {
                    color: #ffffff;
                }

                &:before {
                    margin: -9px 0 0 -16px;
                    left: 0;
                }

                &:after {
                    content: "";
                    left: 0;
                    margin: 0 0 0 -15px;
                    border-top: 17px solid #4500b6;
                }
            }
        }
    }
}
</style>